export default __webpack_public_path__ + "static/media/A0004.4bf86dc9.png";